import { render, staticRenderFns } from "./ToolsPage.vue?vue&type=template&id=0ff1dbca&"
import script from "./ToolsPage.vue?vue&type=script&lang=js&"
export * from "./ToolsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports